import { css } from "@emotion/react";

export function ModalGralCss() {
  return css`
        background:red;

    .Modal {
      h2 {
        background: linear-gradient(90deg, #34c6f1 6.22%, #1fdd8f 77.34%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .content {
        font-style: normal;
        font-weight: 500;
        line-height: 166.667%;
        font-size: calc(0.6rem + 0.9vw);
      }
      .header-with-image{
        background: linear-gradient(90deg, #34c6f1 6.22%, #1fdd8f 77.34%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        
      }
     
    }
  `;
}
